import React from 'react'
import Layout from '../Layout'
import ResourceForm from '../../../Components/ResourceForm'
import FormFieldController from '../../../Components/FormFieldController'
import BackLink from '../../../Components/BackLink'
import { menuItemSchema } from '../../../schemas'

export default function New({
  account,
  accounts,
  navigation,
  categories,
  sittings
}) {
  return (
    <Layout
      account={account}
      accounts={accounts}
      navigation={navigation}
      title="New Menu Item"
    >
      <BackLink href="/manage/menu_items">Back to Menu Items</BackLink>

      <div className="bg-white shadow rounded-lg">
        <ResourceForm
          schema={menuItemSchema}
          resource="menu_item"
          endpoint="/manage/menu_items"
          backLink="/manage/menu_items"
          submitLabel="Create Menu Item"
          defaultValues={{
            name: '',
            description: '',
            price_pence: '',
            category: '',
            sittings: [],
            visible: true,
            popular: false,
            image: null
          }}
        >
          {({ control, errors }) => (
            <>
              <FormFieldController
                control={control}
                name="name"
                label="Name"
                required
                errors={errors}
                placeholder="e.g., Club Sandwich"
              />

              <FormFieldController
                control={control}
                name="description"
                label="Description"
                type="textarea"
                rows={2}
                errors={errors}
                placeholder="Brief description of the item"
              />

              <FormFieldController
                control={control}
                name="price_pence"
                label="Price"
                type="currency"
                required
                errors={errors}
              />

              <FormFieldController
                control={control}
                name="category"
                label="Category"
                type="select"
                options={categories}
                required
                errors={errors}
              />

              <FormFieldController
                control={control}
                name="sittings"
                label="Sittings"
                type="checkboxGroup"
                options={sittings}
                required
                hint="Select which meal periods this item is available"
                errors={errors}
              />

              <FormFieldController
                control={control}
                name="image"
                label="Image"
                type="file"
                accept="image/*"
                hint="Optional. JPG, PNG or WebP recommended."
                errors={errors}
              />

              <FormFieldController
                control={control}
                name="visible"
                label="Visible on menu"
                type="checkbox"
                defaultValue={true}
                hint="Uncheck to hide this item from the customer menu"
                errors={errors}
              />

              <FormFieldController
                control={control}
                name="popular"
                label="Mark as Popular"
                type="checkbox"
                hint="Shows a 'Popular' badge on this item in the guest menu"
                errors={errors}
              />
            </>
          )}
        </ResourceForm>
      </div>
    </Layout>
  )
}
